var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScoreDown(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14500_1743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7375 4.74919C14.5962 4.74181 17.7435 7.87704 17.7508 11.7358C17.7582 15.5945 14.623 18.7418 10.7642 18.7492C6.9055 18.7566 3.75824 15.6213 3.75086 11.7626C3.74348 7.90383 6.87871 4.75658 10.7375 4.74919ZM10.7341 2.9992C5.90411 3.00844 1.99162 6.93593 2.00086 11.7659C2.01011 16.5959 5.9376 20.5084 10.7676 20.4992C15.5976 20.4899 19.5101 16.5624 19.5008 11.7324C19.4916 6.90245 15.5641 2.98995 10.7341 2.9992ZM11.6258 11.7475L11.6191 8.24751L9.86915 8.25086L9.87585 11.7509L7.25085 11.7559L10.7575 15.2492L14.2508 11.7425L11.6258 11.7475Z",
    fill: "#FF0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14500_1743"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScoreDown);
export default __webpack_public_path__ + "static/media/score-down.c0aeab6285a5b1d663884fcc333e29af.svg";
export { ForwardRef as ReactComponent };